import React from "react";

import { graphql } from "gatsby";

import AdidasLogo from "cms/CompanyLogos/logo-adidas.png";
import AtlassianLogo from "cms/CompanyLogos/logo-atlassian.png";
import GoogleLogo from "cms/CompanyLogos/logo-google.png";
import GreenpeaceLogo from "cms/CompanyLogos/logo-greenpeace.png";
import IBMLogo from "cms/CompanyLogos/logo-ibm.png";
import PinterestLogo from "cms/CompanyLogos/logo-pinterest.png";
import SamsungLogo from "cms/CompanyLogos/logo-samsung.png";
import TeslaLogo from "cms/CompanyLogos/logo-tesla.png";

import {
  Container,
  Content,
  Tagline,
  IllustrationWrapper,
  Illustration,
} from "./FeaturedCompaniesBlock.styles";

const LOGO_IMAGES = [
  {
    image: IBMLogo,
    imageAlt: "IBM logo",
  },
  {
    image: TeslaLogo,
    imageAlt: "Tesla logo",
  },
  {
    image: GoogleLogo,
    imageAlt: "Google logo",
  },
  {
    image: GreenpeaceLogo,
    imageAlt: "Greenpeace logo",
  },
  {
    image: PinterestLogo,
    imageAlt: "Pinterest logo",
  },
  {
    image: AtlassianLogo,
    imageAlt: "Atlassian logo",
  },
  {
    image: AdidasLogo,
    imageAlt: "Adidas logo",
  },
  {
    image: SamsungLogo,
    imageAlt: "Samsung logo",
  },
] as const;

export interface FeaturedCompaniesBlockProps
  extends Queries.SanityFeaturedCompaniesBlock {}

const FeaturedCompaniesBlock: React.FC<FeaturedCompaniesBlockProps> = ({
  tagline,
}) => (
  <Container>
    {/* <pre>
      {JSON.stringify({
        tagline,
        companyImages,
      }, null, 2)}
    </pre> */}
    <Content>
      <Tagline>{tagline}</Tagline>
      <IllustrationWrapper>
        {LOGO_IMAGES?.map((companyImage) => (
          <Illustration
            key={companyImage.imageAlt}
            src={companyImage.image}
            alt={companyImage.imageAlt}
          />
        ))}
      </IllustrationWrapper>
    </Content>
  </Container>
);

export const query = graphql`
  fragment FeaturedCompaniesBlock on SanityFeaturedCompaniesBlock {
    _key
    _type
    tagline
  }
`;

export default FeaturedCompaniesBlock;
